import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";

const INR = (n) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

export default function Payments() {
  const { data: rows = [] } = useQuery({ queryKey: ["payments"], queryFn: async () => (await api.get("/payments")).data });
  const total = rows.reduce((s, p) => s + (p.amount || 0), 0);

  return (
    <div data-testid="payments-page">
      <PageHeader
        eyebrow="Business Division · Revenue"
        title="Payments"
        description="All payments received against invoices. Record new payments from the Invoice detail page."
      />
      <div className="max-w-[1400px] mx-auto px-8 py-6 space-y-4">
        <div className="border border-zinc-200 rounded-lg bg-white p-5 flex items-baseline gap-4" data-testid="pay-summary">
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold">Total received</div>
          <div className="font-heading text-2xl font-extrabold text-emerald-700">{INR(total)}</div>
          <div className="text-xs text-zinc-500 font-mono ml-auto">{rows.length} payments</div>
        </div>
        <div className="border border-zinc-200 rounded-lg bg-white overflow-hidden" data-testid="payments-table">
          <table className="w-full text-sm">
            <thead className="bg-zinc-50 border-b border-zinc-200">
              <tr className="text-left text-[10px] uppercase tracking-widest text-zinc-500">
                <th className="px-4 py-3">Paid on</th><th className="px-4 py-3">Invoice</th><th className="px-4 py-3">Method</th><th className="px-4 py-3">Reference</th><th className="px-4 py-3 text-right">Amount</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-100">
              {rows.map((p) => (
                <tr key={p.id} data-testid={`pay-row-${p.id}`}>
                  <td className="px-4 py-3 font-mono text-xs">{p.paid_at}</td>
                  <td className="px-4 py-3 font-mono text-xs">{p.invoice_id}</td>
                  <td className="px-4 py-3 capitalize">{p.method.replace("_", " ")}</td>
                  <td className="px-4 py-3 text-zinc-600 text-xs font-mono">{p.reference || "—"}</td>
                  <td className="px-4 py-3 text-right font-mono">{INR(p.amount)}</td>
                </tr>
              ))}
              {rows.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-sm text-zinc-500">No payments recorded yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
